module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDUwMCA1MDAiPjxzdHlsZT4uc3Qwe29wYWNpdHk6NS4wMDAwMDBlLTAyO2ZpbGw6I2ZmZn08L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjI1MCIgY3k9IjI1MCIgcj0iMjUwIi8+PGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMjUwIiBjeT0iMjUwIiByPSIyMDAiLz48Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIyNTAiIGN5PSIyNTAiIHI9IjE1MCIvPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjI1MCIgY3k9IjI1MCIgcj0iMTAwIi8+PGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMjUwIiBjeT0iMjUwIiByPSI1MCIvPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjI1MCIgY3k9IjI1MCIgcj0iMjUiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404/bg.svg
// module id = 760
// module chunks = 2 3 4 5 45